import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config-service';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { SessionService } from './session.service';

@Injectable()
export class CruceService {
  config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
  }
  
  save(cruce) {
		let url = this.host_api + '/cruce';
		let params = cruce;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});

	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/cruce.service.ts